import React, { useState } from "react";
import { LogIn, Loader2 } from "lucide-react";
import { LOGO_URL } from "../igualdad-data.js";
import { useIgualdad } from "../igualdad-store.jsx";

/* ============================================================
   Talention — Módulo Igualdad · Login
   Se renderiza fuera del shell del módulo (sin la topbar del
   módulo), pero dentro del área de contenido de App A.
   Avisa con onDone() para que el shell vuelva a inicio.
   ============================================================ */

function IgualdadLogin({ onDone }) {
  const { login } = useIgualdad();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [logoErr, setLogoErr] = useState(false);

  async function submit() {
    if (loading) return;
    setLoading(true);
    setError(null);
    try {
      await login(email.trim(), password);
      onDone?.();
    } catch (e) {
      setError(
        e?.status === 422 || e?.status === 401
          ? "Credenciales incorrectas o cuenta desactivada."
          : e?.message || "No se pudo iniciar sesión."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lg-bg">
      <form className="lg-card" onSubmit={(ev) => { ev.preventDefault(); submit(); }}>
        <div className="lg-logo">
          {logoErr
            ? <span className="lg-logo-fallback">talention</span>
            : <img src={LOGO_URL} alt="Talention" onError={() => setLogoErr(true)} />}
          <span className="lg-logo-tool">Igualdad · Transparencia salarial</span>
        </div>

        <h1 className="lg-h1">Iniciar sesión</h1>
        <p className="lg-sub">Accede con tu cuenta para consultar el registro retributivo.</p>

        <label className="lg-label">Correo electrónico</label>
        <input className="lg-input" type="email" value={email} onChange={(ev) => setEmail(ev.target.value)} autoComplete="username" required />

        <label className="lg-label">Contraseña</label>
        <input className="lg-input" type="password" value={password} onChange={(ev) => setPassword(ev.target.value)} autoComplete="current-password" required />

        {error && <div className="lg-error">{error}</div>}

        <button className="lg-btn" type="submit" disabled={loading}>
          {loading ? <Loader2 size={16} className="lg-spin" /> : <LogIn size={16} />}
          {loading ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}

export { IgualdadLogin };
